import { render } from "./VI18nError.vue?vue&type=template&id=6a395f6b&ts=true"
import script from "./VI18nError.vue?vue&type=script&lang=ts"
export * from "./VI18nError.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__